import { Component, OnDestroy, OnInit } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AlertService } from '../services/alert.service';
import { takeWhile } from 'rxjs';
import { AlertTypes } from 'src/app/constants';

@Component({
  selector: 'app-alert-main',
  templateUrl: './alert-main.component.html',
  styleUrls: ['./alert-main.component.scss']
})
export class AlertMainComponent implements OnInit, OnDestroy {

  swalOptions: any;

  destroySubscription = false;

  constructor(private alertService: AlertService) { }

  ngOnInit(): void {
    
  }

  

  

  // error(type: any, text: any) {
  //   Swal.fire({
  //     icon: 'error',
  //     text: text,
  //     buttonsStyling: false,
  //     customClass: {
  //       confirmButton: 'btn btn-custom-success'
  //     }
  //   })
  // }

  // errorHtml(html: any) {
  //   Swal.fire({
  //     icon: 'error',
  //     html: html,
  //     buttonsStyling: false,
  //     customClass: {
  //       confirmButton: 'btn btn-custom-success'
  //     }
  //   })
  // }

  // success(type: any, text: any) {
  //   Swal.fire({
  //     icon: 'success',
  //     text: text,
  //     buttonsStyling: false,
  //     customClass: {
  //       confirmButton: 'btn btn-custom-success'
  //     }
  //   })
  // }

  // info(type: any, text: any) {
  //   Swal.fire({
  //     icon: 'info',
  //     text: text,
  //     buttonsStyling: false,
  //     customClass: {
  //       confirmButton: 'btn btn-custom-success'
  //     }
  //   })
  // }

  ngOnDestroy(): void {
    this.destroySubscription = true;
  }

}
